export const traducciones = {
    AG: {
        "es-AR": "Antigua y Barbuda"
    },
    AR: {
        "es-AR": "Argentina"
    },
    AW: {
        "es-AR": "Aruba"
    },
    BB: {
        "es-AR": "Barbados"
    },
    BO: {
        "es-AR": "Bolivia"
    },
    BR: {
        "es-AR": "Brasil"
    },
    BS: {
        "es-AR": "Bahamas"
    },
    BZ: {
        "es-AR": "Belice"
    },
    CA: {
        "es-AR": "Canada"
    },
    CL: {
        "es-AR": "Chile"
    },
    CO: {
        "es-AR": "Colombia"
    },
    CR: {
        "es-AR": "Costa Rica"
    },
    CU: {
        "es-AR": "Cuba"
    },
    CW: {
        "es-AR": "Curaçao"
    },
    DM: {
        "es-AR": "Mancomunidad de Dominica"
    },
    DO: {
        "es-AR": "República Dominicana"
    },
    EC: {
        "es-AR": "Ecuador"
    },
    ES: {
        "es-AR": "España"
    },
    GD: {
        "es-AR": "Granada"
    },
    GT: {
        "es-AR": "Guatemala"
    },
    GY: {
        "es-AR": "Guyana"
    },
    HN: {
        "es-AR": "Honduras"
    },
    HT: {
        "es-AR": "Haiti"
    },
    IN: {
        "es-AR": "India"
    },
    JM: {
        "es-AR": "Jamaica"
    },
    LC: {
        "es-AR": "Santa Lucia"
    },
    MX: {
        "es-AR": "México"
    },
    NG: {
        "es-AR": "Nigeria"
    },
    NI: {
        "es-AR": "Nicaragua"
    },
    PA: {
        "es-AR": "Panamá"
    },
    PE: {
        "es-AR": "Perú"
    },
    PR: {
        "es-AR": "Puerto Rico"
    },
    PY: {
        "es-AR": "Paraguay"
    },
    SR: {
        "es-AR": "Surinam"
    },
    SV: {
        "es-AR": "El Salvador"
    },
    TT: {
        "es-AR": "Trinidad y Tobago"
    },
    US: {
        "es-AR": "Estados Unidos"
    },
    UY: {
        "es-AR": "Uruguay"
    },
    VC: {
        "es-AR": "San Vicente"
    },
    VE: {
        "es-AR": "Venezuela"
    },
    COUNTRY: {
        "es-AR": "País"
    },
    GENDER: {
        "es-AR": "Genero"
    },
    AGE_RANGE: {
        "es-AR": "Rango de edad"
    },
    FEMALE: {
        "es-AR": "Femenino"
    },
    MALE: {
        "es-AR": "Masculino"
    },
    NONBIN: {
        "es-AR": "No binario"
    },
    "00_TO_18": {
        "es-AR": "Menos de 18"
    },
    "18_TO_24": {
        "es-AR": "Entre 18 y 24"
    },
    "25_TO_34": {
        "es-AR": "Entre 25 y 34"
    },
    "35_TO_44": {
        "es-AR": "Entre 35 y 44"
    },
    "45_TO_54": {
        "es-AR": "Entre 45 y 54"
    },
    "55_TO_XX": {
        "es-AR": "55 y más"
    },

    user_id: {
        "es-AR": "PERFIL - Id de Usuario"
    },
    user_nse: {
        "es-AR": "PERFIL - NSE de Usuario"
    },
    age_range: {
        "es-AR": "PERFIL - Rango de Edad"
    },
    gender: {
        "es-AR": "PERFIL - Género"
    },
    registered_at: {
        "es-AR": "PERFIL - Fecha de Registro"
    },
    ip_based_isp: {
        "es-AR": "PERFIL - Proveedor de Internet"
    },
    device_info: {
        "es-AR": "PERFIL - Modelo de Dispositivo"
    },
    blacklist: {
        "es-AR": "PERFIL - Blacklist"
    },
    apps: {
        "es-AR": "PERFIL - Aplicaciones instaladas"
    },
    city: {
        "es-AR": "PERFIL - Ciudad"
    },
    region: {
        "es-AR": "PERFIL - Región"
    },
    country: {
        "es-AR": "PERFIL - País"
    },
    NOTRAIN: {
        "es-AR": ""
    },
    DONE: {
        "es-AR": "LISTO"
    },
    INITIALIZING: {
        "es-AR": "Inicializandose"
    },
    READY_TO_GET_STATISTICS: {
        "es-AR": "Listo para generar preguntas/apps perfilamiento"
    },
    CALCULATING_STATISTICS: {
        "es-AR": "Generando perfilamiento"
    },
    EMPTY_DATAFRAMES: {
        "es-AR": "Datasets vacíos"
    },
    ERROR_INITIALIZING: {
        "es-AR": "Error en inicialización"
    },
    DATA_FILTERING: {
        "es-AR": "Listo para seleccionar preguntas/apps perfilamiento"
    },
    FILTERS_APPLIED: {
        "es-AR": "Perfilamiento aplicado"
    },
    NORMALIZING_DATASETS: {
        "es-AR": "Normalizando datasets"
    },
    DATASETS_NORMALIZED: {
        "es-AR": "Datasets normalizados"
    },
    CREATING_IN_BIGML: {
        "es-AR": "Creandose en BigML"
    },
    CREATED_IN_BIGML: {
        "es-AR": "Creado en BigML"
    },
    READY_TO_START: {
        "es-AR": "Listo para comenzar entrenamiento/predicciones"
    },
    RUNNING: {
        "es-AR": "Ejecutando entrenamiento/predicciones"
    },
    PREDICTING: {
        "es-AR": "Ejecutando predicciones"
    },
    PAUSED: {
        "es-AR": "Pausado"
    },
    FINISHED: {
        "es-AR": "Finalizado"
    },
    STOPPED: {
        "es-AR": "Pausado con errores"
    }
};
